import { useEffect, useState } from "react";
import { TableColumnTypes } from "../../../Enums/TableColumnTypes";

export const useMergeLinkState = (client) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (client) {
      setTableData(client.mergeAccounts);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(client)]);
  return {
    getters: {
      columns: [
        {
          label: "Integration Name",
          propName: "integrationName",
          type: TableColumnTypes.Text,
        },
        {
          label: "Last Updated",
          propName: "dateLastUpdated",
          type: TableColumnTypes.Date,
        },
      ],
      loading,
      tableData,
    },
    setters: {
      setLoading,
      setTableData,
    },
  };
};
